module.exports = __webpack_public_path__ + "img/ls.lse9b2f4b.svg";